// 右下の LINE 相談ボタン。ファーストビュー（画面1枚分）を過ぎたら出し、戻ったら隠す。
// 最初に出たときだけ、横の「サイズ・刺繍のご相談はLINEで」を数秒見せる。
(() => {
  const button = document.querySelector('[data-line-consult]');
  if (!button) return;

  button.hidden = false;

  let hinted = false;
  let ticking = false;

  const update = () => {
    ticking = false;
    const show = window.scrollY > window.innerHeight;
    button.classList.toggle('is-visible', show);

    if (show && !hinted) {
      hinted = true;
      button.classList.add('is-hinting');
      setTimeout(() => button.classList.remove('is-hinting'), 4000);
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
